import { Page } from 'src/app/core/models/page';
import { SortOrder } from 'src/app/core/interface/sort-order';
export class AirportMaintenanceGetRequest extends Page {
  airportCode: string | null;
  airportName: string | null;
  locatedCitySeqNo: number[] | null;
  sortOrder: SortOrder | null;

  constructor() {
    super();
    this.airportCode = null;
    this.airportName = null;
    this.locatedCitySeqNo = null;
    this.sortOrder = null;
  }
}
